import Joi from '@hapi/joi'

export const DailyCollectionCategoryObject = {
    groupID: Joi.number().invalid(0).required().label("Group Name").messages({
        "any.invalid": `Group Name cannot have invalid characters`,
        "any.required": `Group Name characters`
    }),
    routeID:  Joi.number().required().label("Route Name"),
    factoryID: Joi.number().invalid(0).required().label("Factory Name").messages({
        "any.invalid": `Factory Name cannot have invalid characters`,
        "any.required": `Factory Name Type characters`
    }),
    searchdate: Joi.string().invalid("").label("Search Date"),
    reportType: Joi.number().invalid(0).required().label("Type").messages({
        "any.invalid": `Type cannot have invalid characters`,
        "any.required": `Type is required.`
    }),
    regNo: Joi.string().allow("", null).label("Register Number")
}